import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * @typedef OwnProps
 *
 * @property {string} icon        Icon name
 * @property {string} [className] Class name
 */

/** @typedef {import('react').ComponentPropsWithoutRef<'span'> & OwnProps} Props */

/**
 * @param {Props} props
 * @return {JSX.Element} Element
 */
function Dashicon(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      extraProps = _objectWithoutProperties(_ref, ["icon", "className"]);

  var iconClass = ['dashicon', 'dashicons', 'dashicons-' + icon, className].filter(Boolean).join(' ');
  return createElement("span", _extends({
    className: iconClass
  }, extraProps));
}

export default Dashicon;
//# sourceMappingURL=index.js.map